import { createContext } from 'react'

import { AddEditPageContextType } from './types'

export const AddEditPageContext = createContext<AddEditPageContextType>(
  {} as AddEditPageContextType,
)
